import { z } from 'zod';
import { TFunction } from 'i18next';

import { LocationAddressFilterType } from '@/entities/location';

export const createConsignmentSchema = (t: TFunction) =>
  z.object({
    // Consignment Identification
    // locationGroup: z.string().optional(), // Static field from siteId
    // createdBy: z.string().optional(), // Static field from consignment object
    // trackingCode: z.string().optional(), // Static field from consignment object
    ownersReference: z.string().optional(),

    // Consignment Control
    status: z.enum(['new', 'normal', 'urgent']).default('new'),
    priority: z.enum(['normal', 'high', 'urgent']).default('normal'),
    remarks: z.string().optional(),
    transportUnitQuantity: z.number().or(z.string()).optional(),

    // Point of Contact
    senderOrganization: z.string().optional(),
    senderContact: z.string().optional(),
    receiverOrganization: z.string().optional(),
    receiverContact: z.string().optional(),
    clearingAgent: z.string().optional(),
    clearingAgentContact: z.string().optional(),
    onBehalfOf: z.string().optional(),

    // Starting Point
    startingPointType: z.enum(
      [
        LocationAddressFilterType.CUSTOMER_ADDRESS,
        LocationAddressFilterType.ARRIVAL_PORT_TRANSSHIPMENT,
        LocationAddressFilterType.ARRIVAL_DELIVERY_OR_PICKUP_AT_SITE
      ],
      {
        errorMap: () => ({ message: t('validity.valueMissing.defaultMessage') })
      }
    ),
    arrivingTo: z.string().min(1, t('validity.valueMissing.defaultMessage')), // Location ID from location addresses API
    expectedArrivalDate: z.date().or(z.string()).optional(),
    documentNo: z.string().optional(),
    contactInfo: z.string().optional(),
    instructions: z.string().optional(),

    // Service Identification
    serviceType: z.enum(
      [
        LocationAddressFilterType.CUSTOMER_ADDRESS,
        LocationAddressFilterType.WAREHOUSE_PICKUP,
        LocationAddressFilterType.STORAGE
      ],
      {
        errorMap: () => ({ message: t('validity.valueMissing.defaultMessage') })
      }
    ),
    serviceDestination: z.string().min(1, t('validity.valueMissing.defaultMessage')),
    durationInDays: z.number().or(z.string()).optional(),
    serviceInstructions: z.string().optional(),

    // Planned Movement
    onSiteDate: z.date().or(z.string()).optional(),
    plannedMode: z.enum(['none', 'air', 'road', 'sea', 'rail']).default('none'),
    missionTransporterNumber: z.number().or(z.string()).optional()
  });

export type ConsignmentFormValues = z.infer<ReturnType<typeof createConsignmentSchema>>;
